import { render, staticRenderFns } from "./ItemDisplay.vue?vue&type=template&id=2454b350&scoped=true&"
import script from "./ItemDisplay.vue?vue&type=script&lang=js&"
export * from "./ItemDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ItemDisplay.vue?vue&type=style&index=0&id=2454b350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2454b350",
  null
  
)

component.options.__file = "ItemDisplay.vue"
export default component.exports